<template>
  <validation-observer
      ref="form"
      #default="{ invalid }"
      tag="form"
      class="repeater__form"
      style="overflow: visible"
      :key="key"
  >
    <b-modal
        v-model="show"
        content-class="package-modal rounded-8"
        dialog-class="wameed-modal-md"
        no-fade
    >
      <template slot="modal-header-close">
        <close-icon/>
      </template>
      <template slot="modal-title">
        <div class="d-block text-center">
          <h3 class="text-reg-18">
            {{ modalData != null ? $t('classifications.update_btn') : $t('classifications.new_btn') }}
          </h3>
        </div>
      </template>


      <b-row>
        <b-col md="6" v-for="locale in locales" :key="locale">
          <text-input
              v-model="form['name_'+locale]"
              :label="$t('classifications.form.name_'+locale)"
              :placeholder="$t('form.text.placeholder')"
              name="package-ad"
              rules="required"
          />
        </b-col>
        <b-col md="6">
          <wameed-dropdown
              v-model="form.category"
              :label="$t('classifications.form.category')"
              :placeholder="$t('form.text.placeholder')"
              variant="disable"
              rules="required"
              :items="getVendorCategories"
              title="name"
              class="wameed_dropdown"

              @input="onCategoryChange"
              :no_options="$t('common.no_options')"
          />
        </b-col>
        <b-col md="6">

          <wameed-input-file-upload
              fileType="images"
              field-classes="w-100"
              rule="required"
              functionType="front"
              v-model="form.image.name"
              :label="$t('classifications.form.image')"
              :input-placeholder="$t('form.image.placeholder')"
              :input-append-text="$t('form.image.browse')"
              @changed="uploadProfileImage"
          />
        </b-col>

      </b-row>

      <template slot="modal-footer">
        <wameed-btn
            classes="  text-med-14 text-white mx-0 rounded-8"
            :title="modalData!=null ?$t('btn.update'):$t('btn.add')"
            :disabled="invalid"
            type="submit"
            variant="main"
            @onClick="submitOrder()"
        />
        <wameed-btn
            classes="  text-med-14 text-font-secondary mx-0 rounded-8 "
            :title="$t('btn.cancel')"
            type="button"
            variant="gray"
            @onClick="closeModal()"
        />
      </template>
    </b-modal>
  </validation-observer>
</template>

<script>
import {ValidationObserver, ValidationProvider} from 'vee-validate';
import {WameedBtn, WameedTextInput as TextInput} from 'wameed-ui/dist/wameed-ui.esm';
import {mapActions, mapGetters} from 'vuex';
import {availableLocales} from '@/enums/locales.enum'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    WameedBtn,
    TextInput,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },

    modalData: {
      type: Object,
      default: null,
    },

  },

  data() {
    return {
      key:0,
      locales: availableLocales,
      form: {
        image: '',
      },
      showSuccessModal: false,
    };
  },
  computed: {
    ...mapGetters({
      getVendorCategories: 'utilities/getVendorCategories',
    }),
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit('close');
        }
      },
    },
  },
  watch: {
    modalData(newVal) {
      if (newVal != null) {
        this.form = newVal;
      } else {
        this.form.name = '';
      }
    },
  },
  created() {
    if (this.modalData != null) {
      this.form = this.modalData
    }
  },
  methods: {
    ...mapActions({
      create: "admin/settings/classifications/create",
      update: "admin/settings/classifications/update",
    }),
    uploadProfileImage(value) {
      this.form.image = value;
    },
    onCategoryChange(){
      this.key++;
    },

    submitOrder() {

      if (this.form.category)
        this.form.category_id = this.form.category.id;
      if (this.modalData == null) {
        this.create(this.form).then(() => {
          this.$emit('onComplete', true);
          this.closeModal();
          this.$store.commit('loadingFinish', null, {root: true});
        });
      } else {
        this.update({
          ...this.form,
          id: this.modalData.id,

        }).then(() => {
          this.$emit('onComplete', true);
          this.closeModal();
          this.$store.commit('loadingFinish', null, {root: true});
        });
      }
    },


    closeModal() {
      this.form = {
        image: '',
      };
      this.show = false;
    },
  },
};
</script>
